(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('Factory', Factory);

    Factory.$inject = ['$resource'];

    function Factory ($resource) {
        var resourceUrl =  'api/factories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
